import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { AddDeviceTypeComponent } from "./add-device-type/add-device-type.component";
import { DeviceTypesComponent } from "./device-types.component";

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: DeviceTypesComponent
    },
    {
      path: 'add-device-type',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: AddDeviceTypeComponent
    },
    {
      path: 'edit-device-type/:id',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: AddDeviceTypeComponent
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class DeviceTypesRoutingModule { }